/**
 * 大陆站点路由
 **/
import Dynamic from '@/pages/dynamic'
import Range from '@/pages/range/'
import PayFee from '@/pages/payFee/'
import Login from '@/pages/login'
import Main from '@/pages/main'
import Waybill from '@/pages/waybill'
import WaybillSearch from '@/pages/waybill/waybill-search'
import WaybillDetail from '@/pages/waybill/waybillDetail/index'
import Logout from '@/pages/logout'
import Order from '@/pages/order/'
import User from '@/pages/user/'
import Feedback from '@/pages/feedback/'
import FeedbackSuggest from '@/pages/feedback/feedback-suggestion'
import FeedbackProblem from '@/pages/feedback/feedback-problem'
import FeedbackSucceed from '@/pages/feedback/feedback-succeed'
import ProductDetail from '@/pages/product/detail/'
import ProductList from '@/pages/product/list/'
import SpecialWarehousing from '@/pages/special-warehousing/'
import acceptPrinciple from '@/pages/accept/'
import StoreMap from '@/pages/store/'
import StoreMapQuery from '@/pages/store/query'
import StoreMapNav from '@/pages/store/navigation'
import CouponsLogin from '@/pages/coupons/coupons-login'
import CouponsList from '@/pages/coupons/coupons-list'
import General from '@/pages/coupons/general'
import OverdueG from '@/pages/coupons/overdueg'
import SustainablePage from '@/pages/sustainable'
import SustainableHomePage from '@/pages/sustainable/home'
import SustainableInnovationPage from '@/pages/sustainable/innovation'
import SustainablePartnershipPage from '@/pages/sustainable/partnership'
import SustainableCompanyPage from '@/pages/sustainable/company'
import SustainableCommunityPage from '@/pages/sustainable/community'
import Price from '@/pages/price'
import PriceRule from '@/pages/price/rule'
import RecStandard from '@/pages/recStandard'
import RecStd from '@/pages/recStandard/std'
import RecStandardRes from '@/pages/recStandard/result.vue'
import promotion from '@/pages/promotion'
import promotionList from '@/pages/promotion/list.vue'
import promotionDetail from '@/pages/promotion/detail.vue'
import aboutSf from '@/pages/about-sf'
import sfContent from '@/pages/about-sf/content'
import developmentHistory from '@/pages/about-sf/develop.vue'
import itemsContent from '@/pages/items-content'
import yearContent from '@/pages/year-content'
import yearList from '@/pages/year-content/list'
import yearDetail from '@/pages/year-content/detail'
import investorRelations from '@/pages/investorRelations'
import investorContent from '@/pages/investorRelations/content'
import investorList from '@/pages/investorRelations/list'
import homePage from '@/pages/homePage'
import receiveRange from '@/pages/receive-range'
import packageService from '@/pages/package-service'
import prd from '@/pages/prd'
import investor from '@/pages/investor'
import corporateSurvey from '@/pages/investor/corporate-survey'
import companyAnnouncement from '@/pages/investor/company-announcement'
import stockCharts from '@/pages/investor/stock-charts'
import companyManage from '@/pages/investor/company-manage'
import investorContact from '@/pages/investor/investor-contact'
import report from '@/pages/investor/report'
import reportList from '@/pages/investor/report-list'
import recentList from '@/pages/investor/recent-list'

const DynamicCN = r =>
    require.ensure(
        [],
        () => {
            require('@/assets/lang/cn/ranges')
            require('@/assets/lang/cn/region')
            require('@/assets/lang/cn/payFee')
            require('@/assets/lang/cn/login')
            r(Dynamic)
        },
        'cn'
    )
const cusRoute = [
    {
        path: '/cn/:lang',
        component: DynamicCN,
        redirect: '/cn/sc/prd/home',
        props: route => ({
            noHead: route.query.noHead,
            noFooter: route.query.noFooter,
            region: 'cn'
        }),
        children: [
            // /* TODO: 预渲染 begin
            {
                path: 'prd',
                component: prd,
                children: [
                    // 首页
                    {
                        path: 'home',
                        component: homePage,
                        name: 'homePage',
                        props: route => ({
                            noHead: route.query.noHead
                        }),
                        meta: {
                            metaInfo: {
                                title: '顺丰官网|一路相伴 不负所托',
                                keywords: '顺丰官方网站,顺丰,顺丰速运,顺丰大陆,顺丰中国,顺丰集团,顺丰快递,寄快递,寄件,查件',
                                description: '顺丰集团官网，实时了解或查询顺丰产品服务动态'
                            }
                        }
                    },
                    // 关于顺丰
                    {
                        path: 'about',
                        name: 'aboutSf',
                        component: aboutSf,
                        redirect: 'about/company',
                        children: [
                            {
                                path: 'company',
                                name: 'companyIntroduction',
                                component: sfContent,
                                meta: {
                                    cmsApi: 'getCompanyIntroduce',
                                    metaInfo: {
                                        title: '公司介绍|关于顺丰',
                                        keywords: '顺德,国内第一大快递物流公司,全球第四大快递物流公司,综合物流服务商,智慧供应链,网络规模',
                                        description:
                                            '顺丰是全球第四大的领先快递物流综合服务商。秉承“以用户为中心，以需求为导向，以体验为根本”的思维，为客户提供聚焦行业特性及客户应用场景产品服务及解决方案'
                                    }
                                }
                            },
                            {
                                path: 'vision',
                                name: 'brandIdea',
                                component: sfContent,
                                meta: {
                                    cmsApi: 'getBrandIdea',
                                    metaInfo: {
                                        title: '公司愿景|关于顺丰',
                                        keywords: '顺德,国内第一大快递物流公司,全球第四大快递物流公司,综合物流服务商,智慧供应链,网络规模',
                                        description:
                                            '顺丰是全球第四大的领先快递物流综合服务商。秉承“以用户为中心，以需求为导向，以体验为根本”的思维，为客户提供聚焦行业特性及客户应用场景产品服务及解决方案'
                                    }
                                }
                            },
                            {
                                path: 'honor',
                                name: 'enterpriseHonor',
                                component: sfContent,
                                meta: {
                                    cmsApi: 'getEnterpriseHonor',
                                    metaInfo: {
                                        title: '企业荣誉|关于顺丰',
                                        keywords: '顺德,国内第一大快递物流公司,全球第四大快递物流公司,综合物流服务商,智慧供应链,网络规模',
                                        description:
                                            '顺丰是全球第四大的领先快递物流综合服务商。秉承“以用户为中心，以需求为导向，以体验为根本”的思维，为客户提供聚焦行业特性及客户应用场景产品服务及解决方案'
                                    }
                                }
                            },
                            {
                                path: 'culture',
                                name: 'corporateCulture',
                                component: sfContent,
                                meta: {
                                    cmsApi: 'getCorporateCulture',
                                    metaInfo: {
                                        title: '企业文化|关于顺丰',
                                        keywords: '顺德,国内第一大快递物流公司,全球第四大快递物流公司,综合物流服务商,智慧供应链,网络规模',
                                        description:
                                            '顺丰是全球第四大的领先快递物流综合服务商。秉承“以用户为中心，以需求为导向，以体验为根本”的思维，为客户提供聚焦行业特性及客户应用场景产品服务及解决方案'
                                    }
                                }
                            },
                            {
                                path: 'develop',
                                name: 'developmentHistory',
                                component: developmentHistory,
                                meta: {
                                    cmsApi: 'getDevelopmentHistory',
                                    metaInfo: {
                                        title: '发展历程|关于顺丰',
                                        keywords: '顺德,国内第一大快递物流公司,全球第四大快递物流公司,综合物流服务商,智慧供应链,网络规模',
                                        description:
                                            '顺丰是全球第四大的领先快递物流综合服务商。秉承“以用户为中心，以需求为导向，以体验为根本”的思维，为客户提供聚焦行业特性及客户应用场景产品服务及解决方案'
                                    }
                                }
                            }
                        ]
                    },
                    // 可持续发展
                    {
                        path: 'sustainable',
                        name: 'sustainable',
                        component: SustainablePage,
                        redirect: 'sustainable/home',
                        children: [
                            {
                                path: 'home',
                                name: 'sustainableHome',
                                component: SustainableHomePage,
                                meta: {
                                    scrollTop: true,
                                    metaInfo: {
                                        title: '可持续发展|顺丰官网',
                                        keywords: '可持续发展,绿色环保,传递价值,公益,同心抗疫',
                                        description:
                                            '我们认为，在实现公司经营目标，为股东创造长远价值的同时，促进环境与社会可持续发展，是顺丰所肩负的责任。您的每一次托付，既是承诺更是信任。顺丰致力，透过每一次传递，与您一同促进合作,造就美好，持续放大价值。'
                                    }
                                }
                            },
                            {
                                path: '0Carbon',
                                name: 'sustainableInnovation',
                                component: SustainableInnovationPage,
                                meta: {
                                    scrollTop: true,
                                    metaInfo: {
                                        title: '零碳未来|顺丰可持续发展',
                                        keywords: '零碳未来,顺丰绿色承诺,碳目标白皮书,环保计划,环保目标',
                                        description:
                                            '作为一家肩负社会责任感的企业，顺丰从环境保护和节约资源的目标出发，将科技力量注入自身运营，积极打造可持续发展的供应链服务。同时，顺丰将绿色价值延伸至产业链，携手上下游伙伴及客户，帮助合作伙伴加速低碳转型，实现绿色发展，共建零碳未来。'
                                    }
                                }
                            },
                            {
                                path: 'partner',
                                name: 'sustainablePartnership',
                                component: SustainablePartnershipPage,
                                meta: {
                                    scrollTop: true,
                                    metaInfo: {
                                        title: '人才伙伴|顺丰可持续发展',
                                        keywords: '客户权益,客户隐私,小哥福利,供应商管理',
                                        description:
                                            '顺丰作为国内优质的快递物流综合服务商，服务千家万户，致力让人与人的连接更紧密，使潜能放大，成为共创改变的原动力。'
                                    }
                                }
                            },
                            {
                                path: 'company',
                                name: 'sustainableCompany',
                                component: SustainableCompanyPage,
                                meta: {
                                    scrollTop: true,
                                    metaInfo: {
                                        title: '企业治理|顺丰可持续发展',
                                        keywords: '企业治理,合规经营,风险管理,高质量发展',
                                        description:
                                            '顺丰致力于实现企业价值与社会价值的融合统一，怀揣推动行业可持续发展的美好愿景，积极探索企业的可持续发展之路'
                                    }
                                }
                            },
                            {
                                path: 'community',
                                name: 'sustainableCommunity',
                                component: SustainableCommunityPage,
                                meta: {
                                    scrollTop: true,
                                    metaInfo: {
                                        title: '社会关怀|顺丰可持续发展',
                                        keywords: '传递美好生活,顺丰公益,儿童教育及医疗小哥,快递员,抗疫英雄,抗疫志愿者,灾害救援',
                                        description:
                                            '顺丰深知企业与社会一脉相系，在发展的道路上，始终通过实实在在的行动推动社会点滴进步。公司将不忘初心，继续保持积极的态度、向上的精神，聚集各方力量。'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'news',
                        name: 'news',
                        component: yearContent,
                        redirect: 'news/list',
                        children: [
                            {
                                path: 'list',
                                name: 'newsList',
                                component: yearList,
                                meta: {
                                    module: 'news',
                                    metaInfo: {
                                        title: '新闻资讯|关于顺丰',
                                        keywords: '顺丰资讯 ,顺丰新闻,订阅顺丰,了解顺丰,顺丰发布',
                                        description: '点击了解顺丰集团最新资讯'
                                    }
                                }
                            },
                            {
                                path: 'detail',
                                name: 'newsDetail',
                                component: yearDetail,
                                meta: {
                                    scrollTop: true,
                                    module: 'news',
                                    metaInfo: {
                                        title: '新闻资讯|关于顺丰',
                                        keywords: '顺丰资讯 ,顺丰新闻,订阅顺丰,了解顺丰,顺丰发布',
                                        description: '点击了解顺丰集团最新资讯'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'notices',
                        name: 'notices',
                        component: yearContent,
                        redirect: 'notices/list',
                        children: [
                            {
                                path: 'list',
                                name: 'noticesList',
                                component: yearList,
                                meta: {
                                    module: 'notices',
                                    metaInfo: {
                                        title: '服务公告|关于顺丰',
                                        keywords: '顺丰时效,服务公告,服务动态',
                                        description: '点击获取顺丰全国服务公告'
                                    }
                                }
                            },
                            {
                                path: 'detail',
                                name: 'noticesDetail',
                                component: yearDetail,
                                meta: {
                                    scrollTop: true,
                                    module: 'notices',
                                    metaInfo: {
                                        title: '服务公告|关于顺丰',
                                        keywords: '顺丰时效,服务公告,服务动态',
                                        description: '点击获取顺丰全国服务公告'
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: 'use',
                        component: itemsContent,
                        name: 'privacyPolicy',
                        props: route => ({
                            noHead: route.query.noHead
                        }),
                        meta: {
                            cmsApi: 'getUseItem',
                            metaInfo: {
                                title: '使用条款|顺丰官网',
                                keywords: '使用条款',
                                description: '使用条款'
                            }
                        }
                    },
                    {
                        path: 'network',
                        component: itemsContent,
                        name: 'serviceNetwork',
                        props: route => ({
                            noHead: route.query.noHead
                        }),
                        meta: {
                            cmsApi: 'getServiceNetwork',
                            metaInfo: {
                                title: '服务网络|顺丰官网',
                                keywords: '服务网络',
                                description: '服务网络'
                            }
                        }
                    },
                    {
                        path: 'service',
                        component: itemsContent,
                        name: 'service',
                        props: route => ({
                            noHead: route.query.noHead
                        }),
                        meta: {
                            cmsApi: 'queryContract',
                            apiParams: {
                                type: 'serviceClause'
                            },
                            metaInfo: {
                                title: '顺丰速运服务条款|顺丰控股',
                                keywords: '',
                                description: ''
                            }
                        }
                    },
                    {
                        path: 'package',
                        component: packageService,
                        name: 'packageService',
                        props: route => ({
                            noHead: route.query.noHead,
                            noShip: route.query.noShip,
                            noFooter: route.query.noFooter
                        }),
                        meta: {
                            metaInfo: {
                                title: '包装服务|顺丰增值服务',
                                keywords: '包装,定制包,绿色包装,箱子,袋子,木架,托盘,循环回收,安全包装',
                                description: '为了更好的保障快件安全，顺丰为客户提供更专业、环保、便捷和高效的包装服务'
                            }
                        }
                    },
                    {
                        path: 'investor',
                        component: investor,
                        name: 'investor',
                        children: [
                            {
                                path: '/',
                                name: 'corporateSurvey',
                                component: corporateSurvey,
                                meta: {
                                    metaInfo: {
                                        title: '投资者关系|顺丰控股',
                                        keywords: '顺丰公司简介,顺丰公司介绍,SF公司介绍,顺丰介绍,顺丰实时股价,顺丰股价',
                                        description: '顺丰控股股份有限公司（002352.SZ）创立于1993年，为中国最大、全球第四的综合快递物流集团。'
                                    }
                                }
                            },
                            {
                                path: 'announcement',
                                name: 'companyAnnouncement',
                                component: companyAnnouncement,
                                meta: {
                                    metaInfo: {
                                        title: '公司公告|顺丰控股',
                                        keywords: '顺丰公告、顺丰公司公告',
                                        description: '顺丰公告,顺丰公司公告'
                                    }
                                }
                            },
                            {
                                path: 'stock',
                                name: 'stockCharts',
                                component: stockCharts,
                                meta: {
                                    metaInfo: {
                                        title: '股价图示|顺丰控股',
                                        keywords: '顺丰实时股价,顺丰股价',
                                        description: '顺丰实时股价、顺丰股价'
                                    }
                                }
                            },
                            {
                                path: 'manage',
                                name: 'companyManage',
                                component: companyManage,
                                meta: {
                                    metaInfo: {
                                        title: '公司治理|顺丰控股',
                                        keywords: '顺丰公司架构,顺丰董事会,顺丰监事会,顺丰高级管理人员,顺丰高管',
                                        description: '顺丰公司架构、顺丰董事会、顺丰监事会、顺丰高级管理人员、顺丰高管'
                                    }
                                }
                            },
                            {
                                path: 'contact',
                                name: 'investorContact',
                                component: investorContact,
                                meta: {
                                    metaInfo: {
                                        title: '投资者联络|顺丰控股',
                                        keywords: '顺丰投关联系方式,顺丰投资者电话,顺丰投关电话,顺丰投资者关系热线,顺丰投关热线,顺丰券商覆盖',
                                        description: '投资者关系热线：0755-36395338；投资者关系邮箱：sfir@sf-express.com'
                                    }
                                }
                            },
                            {
                                path: 'report',
                                name: 'report',
                                component: report,
                                meta: {
                                    metaInfo: {
                                        title: '业绩推介|顺丰控股',
                                        keywords:
                                            '顺丰财务报告,顺丰年报,顺丰年度报告,顺丰投资者推介,顺丰投关活动,顺丰近期要闻,顺丰可持续发展,顺丰ESG',
                                        description:
                                            '顺丰财务报告、顺丰年报、顺丰年度报告、顺丰投资者推介、顺丰投关活动、顺丰近期要闻、顺丰可持续发展、顺丰ESG'
                                    }
                                }
                            },
                            {
                                path: 'report-list',
                                name: 'reportList',
                                component: reportList
                            },
                            {
                                path: 'recent-list',
                                name: 'recentList',
                                component: recentList
                            }
                        ]
                    }
                ]
            },
            //  * end */
            {
                path: 'store',
                name: 'storeMap',
                component: StoreMap,
                redirect: 'store/query',
                props: route => ({
                    noFooter: route.query.noFooter
                }),
                children: [
                    {
                        path: 'query',
                        name: 'storeQuery',
                        component: StoreMapQuery,
                        meta: {
                            metaInfo: {
                                title: '服务网点查询|顺丰服务支持',
                                keywords: '顺丰网点,网点查询,服务网点,小区网点',
                                description: '顺丰网点、网点查询、服务网点、小区网点'
                            }
                        }
                    },
                    {
                        path: 'nav',
                        name: 'storeNav',
                        component: StoreMapNav,
                        meta: {
                            metaInfo: {
                                title: '服务网点查询|顺丰服务支持',
                                keywords: '顺丰网点,网点查询,服务网点,小区网点',
                                description: '顺丰网点、网点查询、服务网点、小区网点'
                            }
                        }
                    }
                ]
            },
            {
                path: 'range',
                component: receiveRange,
                name: 'receiveRange',
                props: route => ({
                    noHead: route.query.noHead,
                    noFooter: route.query.noFooter
                }),
                meta: {
                    metaInfo: {
                        title: '收寄范围查询|顺丰服务支持',
                        keywords: '服务范围,收寄范围,收派受限区域查询',
                        description: '服务范围、收寄范围、收派受限区域查询'
                    }
                }
            },
            {
                path: 'price',
                component: Price,
                name: 'price',
                props: route => ({
                    noHead: route.query.noHead,
                    noShip: route.query.noShip,
                    noFooter: route.query.noFooter
                }),
                meta: {
                    metaInfo: {
                        title: '运费时效查询|顺丰服务支持',
                        keywords: '运费时效查询,查运费,查时效,时效标准,计费规则',
                        description:
                            '托寄物的计费重量取体积重量与实际重量两者之间的较大值，若为子母件，则将每件的计费重量进行汇总后计算总运费;预计时效因节假日,天气,交通管控,资源等原因不同日期时间查询会有所差异，具体以系统实时返回为准。'
                    }
                }
            },
            {
                path: 'price/rule',
                component: PriceRule,
                name: 'PriceRule',
                meta: {
                    cmsApi: 'getGeneralRules',
                    metaInfo: {
                        title: '运费时效查询|顺丰服务支持',
                        keywords: '运费时效查询,查运费,查时效,时效标准,计费规则',
                        description:
                            '托寄物的计费重量取体积重量与实际重量两者之间的较大值，若为子母件，则将每件的计费重量进行汇总后计算总运费;预计时效因节假日,天气,交通管控,资源等原因不同日期时间查询会有所差异，具体以系统实时返回为准。'
                    }
                },
                props: route => ({
                    noHead: route.query.noHead,
                    type: route.query.type
                })
            },
            {
                path: 'product/detail/:productCode',
                component: ProductDetail,
                name: 'productDetail',
                meta: {
                    metaInfo: {
                        title: '物流服务|顺丰官网',
                        keywords: '物流服务',
                        description: '物流服务'
                    }
                }
            },
            {
                path: 'package',
                component: packageService,
                name: 'packageService',
                props: route => ({
                    noHead: route.query.noHead,
                    noShip: route.query.noShip,
                    noFooter: route.query.noFooter
                }),
                meta: {
                    metaInfo: {
                        title: '包装服务|顺丰增值服务',
                        keywords: '包装,定制包,绿色包装,箱子,袋子,木架,托盘,循环回收,安全包装',
                        description: '为了更好的保障快件安全，顺丰为客户提供更专业、环保、便捷和高效的包装服务'
                    }
                }
            },
            {
                path: 'warehousing',
                component: SpecialWarehousing,
                name: 'specialWarehousing',
                metaInfo: {
                    title: '特殊入仓|顺丰增值服务',
                    keywords: '特殊入仓,仓库,入仓,送码头,送机场,送仓库,送保税区',
                    description:
                        '若地址为特殊区域（如码头、机场、物流公司/中心/仓库、保税区和海关监管区、会议及展览中心等），需顺丰提供除收派件之外的额外服务（比如预约入仓、排队等候、按指定流程派件、轮候验收、垫付费用等），鉴于手续繁琐加大派送难度，顺丰需按标准收取相关服务费，以减少客户沟通成本及提升收派时效'
                }
            },
            {
                path: 'recStd',
                component: RecStd,
                name: 'recStd',
                props: route => ({
                    noHead: route.query.noHead,
                    noFooter: route.query.noFooter
                })
            },
            {
                path: 'accept',
                component: RecStandard,
                name: 'accept',
                props: route => ({
                    noHead: route.query.noHead,
                    noFooter: route.query.noFooter
                }),
                meta: {
                    metaInfo: {
                        title: '收寄标准查询|顺丰服务支持',
                        keywords: '禁寄物品,限寄物品,可不可以寄,能不能寄',
                        description:
                            '遵守起始国家/地区及目的国家/地区当前适用的法律法规及政府规定是寄件人的义务，因各个国家或地区规定禁止或限制寄递的物品不尽相同，除以上禁寄/限寄物品标准外，建议寄件人还需参考物品寄递起始国家或地区和目的国家或地区的进出口禁寄/限寄物品列表'
                    }
                }
            },
            {
                path: 'accept/result',
                component: RecStandardRes,
                name: 'recStandardRes',
                props: route => ({
                    noHead: route.query.noHead
                }),
                meta: {
                    metaInfo: {
                        title: '收寄标准查询|顺丰服务支持',
                        keywords: '禁寄物品,限寄物品,可不可以寄,能不能寄',
                        description:
                            '遵守起始国家/地区及目的国家/地区当前适用的法律法规及政府规定是寄件人的义务，因各个国家或地区规定禁止或限制寄递的物品不尽相同，除以上禁寄/限寄物品标准外，建议寄件人还需参考物品寄递起始国家或地区和目的国家或地区的进出口禁寄/限寄物品列表'
                    }
                }
            },
            {
                path: 'waybill/search',
                component: WaybillSearch,
                name: 'WaybillSearch',
                meta: {
                    metaInfo: {
                        title: '查快递|顺丰服务支持',
                        keywords: '我的包裹,运单追踪,查路由,查单,查快递,我收的,我寄的',
                        description: '我的包裹、运单追踪、查路由、查单、查快递、我收的、我寄的'
                    }
                }
            },
            {
                path: 'waybill/detail/:bno',
                component: WaybillDetail,
                name: 'WaybillDetail',
                meta: {
                    metaInfo: {
                        title: '查快递|顺丰服务支持',
                        keywords: '我的包裹,运单追踪,查路由,查单,查快递,我收的,我寄的',
                        description: '我的包裹、运单追踪、查路由、查单、查快递、我收的、我寄的'
                    }
                }
            }
        ]
    },
    // 404通配
    {
        path: '*',
        redirect: '/cn/sc/prd/home'
    }
]
const orgRoute = {
    path: '/cn/:lang',
    component: Main,
    props: {
        region: 'cn'
    },
    children: [
        {
            path: 'dynamic_functions',
            component: DynamicCN,
            props: route => ({
                noHead: route.query.noHead,
                noFooter: route.query.noFooter,
                region: 'cn'
            }),
            children: [
                {
                    // 无用
                    path: 'range',
                    component: Range,
                    name: 'range'
                },
                {
                    // 无用
                    path: 'payFee',
                    component: PayFee,
                    name: 'payFee'
                },
                {
                    // 无用
                    path: 'waybill',
                    component: Waybill,
                    name: 'waybill'
                },
                {
                    path: 'waybill/search',
                    component: WaybillSearch,
                    name: 'WaybillSearch'
                },
                {
                    path: 'waybill/detail/:bno',
                    component: WaybillDetail,
                    name: 'WaybillDetail'
                },
                {
                    // 无用
                    path: 'order',
                    component: Order,
                    name: 'order'
                },
                {
                    // 无用
                    path: 'user',
                    component: User,
                    name: 'user'
                },
                {
                    // 无用
                    path: 'feedback',
                    component: Feedback,
                    name: 'feedback'
                },
                {
                    // 无用
                    path: 'feedback/feedback-suggestion',
                    component: FeedbackSuggest,
                    name: 'feedbackSuggest'
                },
                {
                    // 无用
                    path: 'feedback/feedback-problem',
                    component: FeedbackProblem,
                    name: 'feedbackProblem'
                },
                {
                    // 无用
                    path: 'feedback/feedback-succeed',
                    component: FeedbackSucceed,
                    name: 'feedbackSucceed'
                },
                {
                    path: 'accept',
                    component: RecStandard,
                    name: 'accept',
                    props: route => ({
                        noHead: route.query.noHead,
                        noFooter: route.query.noFooter
                    })
                },
                {
                    // 无用
                    path: 'recStandard',
                    component: RecStandard,
                    name: 'recStandard',
                    props: route => ({
                        noHead: route.query.noHead
                    })
                },
                {
                    path: 'news',
                    name: 'news',
                    component: yearContent,
                    redirect: 'news/list',
                    children: [
                        {
                            path: 'list',
                            name: 'newsList',
                            component: yearList,
                            meta: {
                                module: 'news',
                                title: '新闻资讯'
                            }
                        },
                        {
                            path: 'detail',
                            name: 'newsDetail',
                            component: yearDetail,
                            meta: {
                                scrollTop: true,
                                module: 'news',
                                title: '新闻详情'
                            }
                        }
                    ]
                },
                {
                    path: 'notices',
                    name: 'notices',
                    component: yearContent,
                    redirect: 'notices/list',
                    children: [
                        {
                            path: 'list',
                            name: 'noticesList',
                            component: yearList,
                            meta: {
                                module: 'notices',
                                title: '服务公告'
                            }
                        },
                        {
                            path: 'detail',
                            name: 'noticesDetail',
                            component: yearDetail,
                            meta: {
                                scrollTop: true,
                                module: 'notices',
                                title: '公告详情'
                            }
                        }
                    ]
                },
                {
                    path: 'recStandard/result',
                    component: RecStandardRes,
                    name: 'recStandardRes',
                    props: route => ({
                        noHead: route.query.noHead
                    })
                },
                {
                    path: 'price',
                    component: Price,
                    name: 'price',
                    props: route => ({
                        noHead: route.query.noHead,
                        noShip: route.query.noShip,
                        noFooter: route.query.noFooter
                    })
                },
                {
                    path: 'price-rule',
                    component: PriceRule,
                    name: 'PriceRule',
                    meta: {
                        cmsApi: 'getGeneralRules'
                    },
                    props: route => ({
                        noHead: route.query.noHead,
                        type: route.query.type
                    })
                },
                {
                    // 无用
                    path: 'accept/accept-principle',
                    component: acceptPrinciple,
                    name: 'acceptPrinciple',
                    props: route => ({
                        noHead: route.query.noHead
                    })
                },
                {
                    path: 'store',
                    name: 'storeMap',
                    component: StoreMap,
                    redirect: 'store/query',
                    props: route => ({
                        noFooter: route.query.noFooter
                    }),
                    children: [
                        {
                            path: 'query',
                            name: 'storeQuery',
                            component: StoreMapQuery
                        },
                        {
                            path: 'nav',
                            name: 'storeNav',
                            component: StoreMapNav
                        }
                    ]
                },
                {
                    path: 'product/detail/:productCode',
                    component: ProductDetail,
                    name: 'productDetail'
                },
                {
                    path: 'package-service',
                    component: packageService,
                    name: 'packageService',
                    props: route => ({
                        noHead: route.query.noHead,
                        noShip: route.query.noShip,
                        noFooter: route.query.noFooter
                    })
                },
                {
                    path: 'special-warehousing',
                    component: SpecialWarehousing,
                    name: 'specialWarehousing'
                },
                {
                    // 无用
                    path: 'product/list',
                    component: ProductList,
                    name: 'productList'
                },
                {
                    // 无用 ???
                    path: 'couponslogin',
                    name: 'couponslogin',
                    component: CouponsLogin,
                    props: route => ({
                        noHead: route.query.noHead
                    })
                },
                {
                    // 无用???
                    path: 'couponslist',
                    name: 'couponslist',
                    component: CouponsList,
                    props: route => ({
                        noHead: route.query.noHead
                    }),
                    children: [
                        {
                            path: 'general',
                            component: General,
                            name: 'general'
                        },
                        {
                            path: 'overdueg',
                            component: OverdueG,
                            name: 'overdueg'
                        }
                    ]
                },
                {
                    path: 'sustainable',
                    name: 'sustainable',
                    component: SustainablePage,
                    redirect: 'sustainable/home',
                    children: [
                        {
                            path: 'home',
                            name: 'sustainableHome',
                            component: SustainableHomePage,
                            meta: {
                                scrollTop: true
                            }
                        },
                        {
                            path: 'innovation',
                            name: 'sustainableInnovation',
                            component: SustainableInnovationPage,
                            meta: {
                                scrollTop: true
                            }
                        },
                        {
                            path: 'partnership',
                            name: 'sustainablePartnership',
                            component: SustainablePartnershipPage,
                            meta: {
                                scrollTop: true
                            }
                        },
                        {
                            path: 'company',
                            name: 'sustainableCompany',
                            component: SustainableCompanyPage,
                            meta: {
                                scrollTop: true
                            }
                        },
                        {
                            path: 'community',
                            name: 'sustainableCommunity',
                            component: SustainableCommunityPage,
                            meta: {
                                scrollTop: true
                            }
                        }
                    ]
                },
                {
                    // 无用
                    path: 'promotion',
                    name: 'promotion',
                    component: promotion,
                    redirect: 'promotion/list',
                    children: [
                        {
                            path: 'list',
                            name: 'promotionList',
                            component: promotionList,
                            meta: {
                                title: '促销活动'
                            }
                        },
                        {
                            path: 'detail',
                            name: 'promotionDetail',
                            component: promotionDetail,
                            meta: {
                                scrollTop: true,
                                title: '活动详情'
                            }
                        }
                    ]
                },
                {
                    path: 'about-sf',
                    name: 'aboutSf',
                    component: aboutSf,
                    redirect: 'about-sf/company-introduction',
                    children: [
                        {
                            path: 'company-introduction',
                            name: 'companyIntroduction',
                            component: sfContent,
                            meta: {
                                cmsApi: 'getCompanyIntroduce',
                                title: '公司介绍'
                            }
                        },
                        {
                            path: 'brand-idea',
                            name: 'brandIdea',
                            component: sfContent,
                            meta: {
                                cmsApi: 'getBrandIdea',
                                title: '公司愿景'
                            }
                        },
                        {
                            path: 'enterprise-honor',
                            name: 'enterpriseHonor',
                            component: sfContent,
                            meta: {
                                cmsApi: 'getEnterpriseHonor',
                                title: '企业荣誉'
                            }
                        },
                        {
                            path: 'sustainable-development',
                            name: 'sustainableDevelopment',
                            component: sfContent,
                            meta: {
                                cmsApi: 'getSustainableDevelopment',
                                title: '可持续发展'
                            }
                        },
                        {
                            path: 'corporate-culture',
                            name: 'corporateCulture',
                            component: sfContent,
                            meta: {
                                cmsApi: 'getCorporateCulture',
                                title: '企业文化'
                            }
                        },
                        {
                            path: 'development-history',
                            name: 'developmentHistory',
                            component: developmentHistory,
                            meta: {
                                cmsApi: 'getDevelopmentHistory',
                                title: '发展历程'
                            }
                        }
                    ]
                },
                {
                    path: 'investor-relation',
                    name: 'investorRelation',
                    component: investorRelations,
                    redirect: 'investor-relation/corporate-governance',
                    children: [
                        {
                            // 公司治理
                            path: 'corporate-governance',
                            name: 'corporateGovernance',
                            component: investorContent,
                            meta: {
                                cmsApi: 'getCorporateGovernance',
                                title: '公司治理'
                            }
                        },
                        {
                            // 公司公告
                            path: 'company-announcement',
                            name: 'companyAnnouncement',
                            component: investorList,
                            meta: {
                                cmsApi: 'getCompanyAnnouncement',
                                title: '公司公告'
                            }
                        },
                        {
                            // 财务报告
                            path: 'financial-report',
                            name: 'financialReport',
                            component: investorList,
                            meta: {
                                cmsApi: 'getFinancialReport',
                                title: '财务报告'
                            }
                        },
                        {
                            // 社会责任报告
                            path: 'social-responsibility-report',
                            name: 'socialResponsibilityReport',
                            component: investorList,
                            meta: {
                                cmsApi: 'getSocialResponsibilityReports',
                                title: '社会责任报告'
                            }
                        },
                        {
                            // 投资者联络
                            path: 'investor-contact',
                            name: 'investorContact',
                            component: investorContent,
                            meta: {
                                cmsApi: 'getInvestorContacts',
                                title: '投资者联络'
                            }
                        },
                        {
                            // 董事会
                            path: 'board-of-director',
                            name: 'boardOfDirector',
                            component: investorList,
                            meta: {
                                cmsApi: 'getBoardOfDirector',
                                title: '董事会'
                            }
                        },
                        {
                            // 股东会
                            path: 'board-of-shareholder',
                            name: 'boardOfShareholder',
                            component: investorList,
                            meta: {
                                cmsApi: 'getBoardOfShareholder'
                            }
                        },
                        {
                            // 投资者活动日
                            path: 'investor-day',
                            name: 'investorDay',
                            component: investorList,
                            meta: {
                                cmsApi: 'getInvestorDays'
                            }
                        }
                    ]
                },
                {
                    path: 'privacy-policy',
                    component: itemsContent,
                    name: 'privacyPolicy',
                    props: route => ({
                        noHead: route.query.noHead
                    }),
                    meta: {
                        cmsApi: 'getPrivacyPolicy',
                        title: '隐私政策'
                    }
                },
                {
                    path: 'use-iterm',
                    component: itemsContent,
                    name: 'privacyPolicy',
                    props: route => ({
                        noHead: route.query.noHead
                    }),
                    meta: {
                        cmsApi: 'getUseItem',
                        title: '使用条款'
                    }
                },
                {
                    path: 'service-network',
                    component: itemsContent,
                    name: 'serviceNetwork',
                    props: route => ({
                        noHead: route.query.noHead
                    }),
                    meta: {
                        cmsApi: 'getServiceNetwork',
                        title: '服务网络'
                    }
                },
                {
                    path: 'index',
                    component: homePage,
                    name: 'homePage',
                    redirect: 'prd/home',
                    props: route => ({
                        noHead: route.query.noHead
                    })
                },
                {
                    path: 'receive-range',
                    component: receiveRange,
                    name: 'receiveRange',
                    props: route => ({
                        noHead: route.query.noHead,
                        noFooter: route.query.noFooter
                    })
                }
            ]
        },
        {
            path: 'login',
            name: 'login',
            component: Login
        },
        {
            path: 'logout',
            name: 'logout',
            component: Logout
        }
    ]
}

export default [...cusRoute, orgRoute]



// WEBPACK FOOTER //
// ./src/router/region-cn.js